/**
 * @generated SignedSource<<62ca11d05a894cb6e41a2ed8909381d4>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type UpdateIdentityResponseError =
  | 'ADDRESS_INVALID'
  | 'BIRTHDAY_INVALID'
  | 'CREDIT_APPLICATION_NOT_FOUND'
  | 'EMAIL_INVALID'
  | 'NAME_INVALID'
  | 'PHONE_NUMBER_INVALID'
  | 'PROFILE_PICTURE_INVALID'
  | 'RH_ADDRESS_UPDATE_FAILED'
  | 'SOCIAL_SECURITY_NUMBER_INVALID'
  | 'UNAUTHORIZED'
  | 'UNEXPECTED_ERROR'
  | '%future added value';
export type UpdateIdentityName = {
  firstName: string;
  lastName: string;
  middleName?: string | null;
};
export type IDVFailPageMutation$variables = {
  bornAt?: number | null;
  creditApplicationId: string;
  identityId: string;
  name?: UpdateIdentityName | null;
  ssn?: string | null;
};
export type IDVFailPageMutation$data = {
  readonly updateIdentity: {
    readonly data: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<UpdateIdentityResponseError>;
  };
};
export type IDVFailPageMutation = {
  response: IDVFailPageMutation$data;
  variables: IDVFailPageMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'bornAt',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'creditApplicationId',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'identityId',
    },
    v3 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'name',
    },
    v4 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'ssn',
    },
    v5 = [
      {
        alias: null,
        args: [
          {
            fields: [
              {
                kind: 'Variable',
                name: 'bornAt',
                variableName: 'bornAt',
              },
              {
                kind: 'Variable',
                name: 'creditApplicationId',
                variableName: 'creditApplicationId',
              },
              {
                kind: 'Variable',
                name: 'identityId',
                variableName: 'identityId',
              },
              {
                kind: 'Variable',
                name: 'name',
                variableName: 'name',
              },
              {
                kind: 'Variable',
                name: 'ssn',
                variableName: 'ssn',
              },
            ],
            kind: 'ObjectValue',
            name: 'q',
          },
        ],
        concreteType: 'UpdateIdentityResponseValidation',
        kind: 'LinkedField',
        name: 'updateIdentity',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'Identity',
            kind: 'LinkedField',
            name: 'data',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'id',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'errors',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'IDVFailPageMutation',
      selections: v5 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v2 /*: any*/, v1 /*: any*/, v3 /*: any*/, v0 /*: any*/, v4 /*: any*/],
      kind: 'Operation',
      name: 'IDVFailPageMutation',
      selections: v5 /*: any*/,
    },
    params: {
      cacheID: '1ffd7b84eb7d9d43e5c595f3c558f5e5',
      id: null,
      metadata: {},
      name: 'IDVFailPageMutation',
      operationKind: 'mutation',
      text: 'mutation IDVFailPageMutation(\n  $identityId: String!\n  $creditApplicationId: String!\n  $name: UpdateIdentityName\n  $bornAt: Long\n  $ssn: String\n) {\n  updateIdentity(q: {identityId: $identityId, creditApplicationId: $creditApplicationId, name: $name, bornAt: $bornAt, ssn: $ssn}) {\n    data {\n      id\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = '96d4d2b25befd142b80b506a3e527bf1';

export default node;
